import { useEffect } from "react";
import { useConfiguration } from "@/contexts/ConfigProvider";
import { MixpanelService } from "@/services/mixpanel.service";
import { syncCurrentUserToMixpanel } from "@/stores/auth-store";

/**
 * Initializes Mixpanel after runtime config loads, then syncs the current user.
 * Auth often resolves before config, and identify is a no-op until init finishes.
 */
export function MixpanelInitializer() {
	const config = useConfiguration();

	useEffect(() => {
		if (!config) return;

		MixpanelService.initialize(config)
			.then(() => {
				if (MixpanelService.isInitialized()) {
					syncCurrentUserToMixpanel();
				}
			})
			.catch((error) => {
				console.warn("Mixpanel initialization error:", error);
			});
	}, [config]);

	return null;
}
